export const categories = [
  {
    id: 'quanshen-fangsong',
    name: '全身放松按摩',
    icon: 'ri-body-scan-line',
    description: '从头部到脚部的全身放松按摩教程，帮助缓解日常疲劳，促进全身血液循环，让身体恢复活力与平衡。',
    keywords: '全身放松按摩,全身按摩视频,放松按摩教程',
  },
  {
    id: 'jianjing',
    name: '肩颈按摩',
    icon: 'ri-user-heart-line',
    description: '针对长期伏案工作的肩颈酸痛问题，提供专业肩颈按摩手法教学，有效缓解肩周炎和颈椎不适。',
    keywords: '肩颈按摩视频,肩颈按摩教程,颈椎按摩手法',
  },
  {
    id: 'yaobei',
    name: '腰背按摩',
    icon: 'ri-heart-pulse-line',
    description: '久坐腰酸背痛怎么办？专业腰背按摩手法视频教程，针对腰肌劳损和背部紧张提供有效的放松方案。',
    keywords: '腰背按摩视频,腰部按摩教程,背部放松按摩',
  },
  {
    id: 'xuewei',
    name: '穴位按摩教学',
    icon: 'ri-focus-3-line',
    description: '系统学习人体重要穴位的按摩方法，掌握穴位定位与按压技巧，通过穴位按摩调理身体，改善亚健康状态。',
    keywords: '穴位按摩视频教学,穴位按摩教程,经络按摩视频',
  },
  {
    id: 'zudi',
    name: '足底反射区',
    icon: 'ri-footprint-line',
    description: '深入讲解足底反射区按摩原理与手法，通过刺激足部反射区来调理全身脏腑功能，改善睡眠质量。',
    keywords: '足底反射区按摩,足底按摩视频,足部按摩教程',
  },
  {
    id: 'toubu',
    name: '头部按摩',
    icon: 'ri-mental-health-line',
    description: '头部穴位按摩与头皮放松技法大全，有效缓解头痛、失眠和精神紧张，让您享受深度放松体验。',
    keywords: '头部按摩视频,头部按摩教程,头皮放松按摩',
  },
];

export const getCategoryById = (id: string) => categories.find((c) => c.id === id);